import { useMemo } from 'react'
import { BOARDS_HEIGHT_MAX, BOARDS_HEIGHT_MIN } from './boardsSectionTokens.js'
import { useBoardsSectionResize } from './useBoardsSectionResize.js'

export function useBoardsSectionModel({
  showAll = false,
  pinnedThreadIds = [],
  threads = [],
  boards = [],
  selectedThreadId,
  onBoardClick,
  onSelectThread,
  onThreadMenuAction,
  onRenameThread,
}) {
  const title = showAll ? 'All Boards' : 'Boards'
  const resize = useBoardsSectionResize()
  const pinnedThreads = useMemo(
    () => pinnedThreadIds.map((id) => threads.find((t) => t.id === id)).filter(Boolean),
    [pinnedThreadIds, threads],
  )

  return {
    title,
    resize,
    pinnedThreads,
    showAll,
    boards,
    selectedThreadId,
    onBoardClick,
    onSelectThread,
    onThreadMenuAction,
    onRenameThread,
    boardsHeightMin: BOARDS_HEIGHT_MIN,
    boardsHeightMax: BOARDS_HEIGHT_MAX,
  }
}
